export default function bookmarkPage() {
	
	if(window.external && ('AddFavorite' in window.external)) { // Internet Explorer
		window.external.AddFavorite(window.location.href,document.title); 
	} else { // For the other browsers (mainly WebKit) we use a simple alert to inform users that they can add to bookmarks with ctrl+D/cmd+D
		alert('Drücken Sie auf ihrer Tastatur die Taste ' + (navigator.userAgent.toLowerCase().indexOf('mac') !== - 1 ? '[CMD] (Command)' : '[CTRL]') + ' und [D] um diese Seite in Ihre Lesezeichen zu speichern.');
	}
	// If you have something in the `href` of your trigger
	return false;
};